export default __webpack_public_path__ + "static/media/Barret-M82a1-Remote-08.c8d0e8c8.jpg";